import React, { useEffect, useRef } from 'react';
interface WaveformVisualizerProps {
  isRecording: boolean;
}
const WaveformVisualizer: React.FC<WaveformVisualizerProps> = ({
  isRecording
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const animationRef = useRef<number>();
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    // Set canvas dimensions
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    const drawWaveform = () => {
      if (!ctx) return;
      // Clear canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (isRecording) {
        // Draw active waveform
        ctx.lineWidth = 2;
        ctx.strokeStyle = '#f56565'; // Red color
        ctx.beginPath();
        const segments = 100;
        const segmentWidth = canvas.width / segments;
        for (let i = 0; i < segments; i++) {
          const x = i * segmentWidth;
          // Generate random height for recording visualization
          const height = isRecording ? Math.random() * (canvas.height * 0.8) + canvas.height * 0.1 : canvas.height / 2;
          ctx.lineTo(x, height);
        }
        ctx.stroke();
      } else {
        // Draw inactive waveform (straight line)
        ctx.lineWidth = 2;
        ctx.strokeStyle = '#718096'; // Gray color
        ctx.beginPath();
        ctx.moveTo(0, canvas.height / 2);
        ctx.lineTo(canvas.width, canvas.height / 2);
        ctx.stroke();
      }
      animationRef.current = requestAnimationFrame(drawWaveform);
    };
    drawWaveform();
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isRecording]);
  return <div className="w-full h-24 bg-gray-900 rounded-lg overflow-hidden" data-id="element-34">
      <canvas ref={canvasRef} className="w-full h-full" data-id="element-35" />
    </div>;
};
export default WaveformVisualizer;